module.exports = __webpack_public_path__ + "montserrat-extrabold-webfont.e63628f192bd25b2b12e.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-extrabold-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-extrabold-webfont.woff
// module chunks = styles